<template>
  <div>
    <!-- 考场状态弹窗 -->
    <div class="to_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.centerDialogVisible"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p>
            账号：<span>{{ userObj.userName }}</span>
          </p>
          <p>
            姓名：<span>{{ userObj.realName }}</span>
          </p>
          <p>请核对您的考试信息，若信息不符，请联系监考员。</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="dialogVisibleObj.centerDialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 交卷提示框 -->
    <div class="info_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.carryOutInfo"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p v-if="infoType == 0">请您先答题,再交卷!</p>
          <p v-else-if="infoType == 1">
            您还有{{
              $parent.answerArr.length - $parent.userAbswerArr.length
            }}道题未答，交卷后的试卷将不能再作答，您确定要交卷？
          </p>
          <p v-else-if="infoType == 2">
            交卷后的试卷将不能再作答，您确定要交卷？
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogVisibleObj.carryOutInfo = false"
            v-if="infoType !== 0"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="dialogVisibleObj.carryOutInfo = false"
            v-if="infoType == 0"
            >确 定</el-button
          >
          <el-button
            v-else-if="infoType != 0"
            type="primary"
            :loading="sundflag"
            @click="theirPapersFun('normal')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 考试结束提示框 -->
    <div class="Finish_view">
      <el-dialog
        title="考试结束"
        :visible.sync="dialogVisibleObj.examFinish"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="toExamlist"
      >
        <p v-if="infoType == 'sys'">
          考试时间已到，系统已经帮您交卷
          <br />
          请点击确定退出答题界面
        </p>
        <div class="mian" v-else>
          <img src="../../../assets/oldKhy/clock1.png" alt="" />
          <p>您已成功提交试卷</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="toExamlist">{{
            infoType == "sys" ? "确定" : "考试结束"
          }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 用于列表状态提示 -->
    <div class="infoTxt_view">
      <el-dialog
        :title="title"
        :visible.sync="dialogVisibleObj.textInfo"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <div v-if="infoTxt == 0" class="box1">
            <p>考试名称：{{ statePopupstatus.ExamName }}</p>
            <div>
              <p>
                <span>总分</span>
                <br />
                {{ $parent.userScoreExam.TotalScore }}
              </p>
              <p>
                <span>考试得分</span>
                <br />
                {{ $parent.userScoreExam.Score }}
              </p>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisibleObj.textInfo = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ksPcApi from "@/api/examPc";
import loginvuex from "@/store/index";
import training from "@/api/trainingApi";
export default {
  props: ["statePopupstatus", "infoType", "title", "infoTxt"],
  data() {
    return {
      dialogVisibleObj: {
        centerDialogVisible: false,
        carryOutInfo: false, // 交卷提示
        examFinish: false, // 考试结束提示
        textInfo: false, // 列表状态提示弹窗
      },
      userObj: {},
      sundflag: false, // 结束考试防抖
      userID: "",
    };
  },
  methods: {
    // 提交试卷接口
    async theirPapersFun(model) {
      const passScore = this.$parent.sourceData.PassScore; // 及格分数
      let newArr = this.$parent.userAbswerArr.filter((item) => {
        // 过滤正确得分
        return item.IsRight == true;
      });
      let newAndScore = newArr.map((item) => {
        // 过滤分值
        return item.Score;
      });
      let num = 0;
      for (let i = 0; i < newAndScore.length; i++) {
        num += Number(newAndScore[i]);
      }
      let examJson = this.$parent.userAbswerArr.map((item) => {
        return {
          TestID: item.TestID,
          ChildTableID: item.ChildTableID,
          UserAnswer: item.UserAnswer,
          IsRight: item.IsRight,
        };
      });
      let examobj = {
        Score: num, // 得分
        IsPass: num >= passScore ? 1 : 0, // 是否及格 0 不及格 1及格
        resultExamID: this.$parent.sourceData.ExamResultID,
      };
      let obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        examID: this.$route.query.examID,
        examResultJson: JSON.stringify(examJson),
        examJSON: JSON.stringify(examobj), // 得分
        Model: model, // 正常交卷 sys系统收卷 Cut 切屏交卷
      };
      this.sundflag = true;
      const { data } = await ksPcApi.submitExamResult(obj);
      if (data.Status == 200) {
        // 培训提交
        this.creditRecord();
        if (model == "normal") {
          // 系统自动收卷
          this.dialogVisibleObj.carryOutInfo = false;
        }
        this.dialogVisibleObj.examFinish = true; // 开启考试结束弹窗
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        localStorage.removeItem(
          `anIndex${this.$route.query.examID}_${this.userID}`
        ); // 清除用户答题进度
        localStorage.removeItem(
          `userAbswerArr${this.$route.query.examID}_${this.userID}`
        ); // 清除用户答案
        localStorage.removeItem(
          `sourceData${this.$route.query.examID}_${this.userID}`
        ); // 清除试题数据
        localStorage.removeItem(
          `TestBeginTime${this.$route.query.examID}_${this.userID}`
        ); // 清除试题数据
        this.$parent.clearTimer(); // 消除定时器
      } else {
        this.sundflag = false;
        this.$message.error(data.Msg);
      }
      console.log(data);
    },
    // 跳转考试列表
    toExamlist() {
      // 弹窗这里出现返回路由必须弹出拦截
      // this.dialogVisibleObj.examFinish = false

      this.$router.push({
        path: "/examination/table",
        query: { type: "ks" },
      });
    },
    async creditRecord() {
      const obj = {
        type: "exam",
        typeID: this.$route.query.examID,
      };
      const { data } = await training.submitCredit(obj);
      if (data.Status !== 200) {
        this.$message({
          message: data.Data,
          type: "warning",
        });
      }
    },
  },
  created() {
    this.userObj = JSON.parse(localStorage.getItem("userlist"));
    this.userID = JSON.parse(loginvuex.state.userlist).userID;
  },
};
</script>

<style lang="scss" scoped>
.to_view {
  .mian {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      margin-bottom: 10px;
      span {
        letter-spacing: 1px;
      }
    }
  }
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
}
::v-deep .to_view .el-dialog {
  width: 441px;
  min-height: 200px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  span > button {
    width: 88px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    // margin-top: 38px;
    margin-bottom: 14px;

    &:nth-child(2) {
      margin-left: 50px;
    }
  }
}
.info_view {
  .mian {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      margin-bottom: 10px;
      font-size: 18px;
      letter-spacing: 1px;
      span {
        letter-spacing: 1px;
      }
    }
  }
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
}
::v-deep .info_view .el-dialog {
  width: 441px;
  min-height: 200px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}
.Finish_view {
  .mian {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      margin-bottom: 10px;
      font-size: 18px;
      letter-spacing: 1px;
      margin-top: 24px;
    }
  }
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
}
::v-deep .Finish_view .el-dialog {
  width: 600px;
  min-height: 200px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
  .dialog-footer {
    .el-button {
      width: 300px;
      height: 40px;
      font-size: 20px;
      letter-spacing: 2px;
      background: #3f92da;
    }
    margin-bottom: 36px;
  }
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
  font-size: 24px;
}
.infoTxt_view {
  .mian {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .box1 {
      > div {
        width: 262px;
        height: 92px;
        border: 1px solid #ededed;
        margin-top: 24px;
        display: flex;
        text-align: center;
        > p {
          flex: 1;
          line-height: 40px;
          > span {
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
}
::v-deep .infoTxt_view .el-dialog {
  width: 600px;
  min-height: 200px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
  .dialog-footer {
    .el-button {
      width: 300px;
      height: 40px;
      font-size: 20px;
      letter-spacing: 2px;
      background: #3f92da;
    }
    margin-bottom: 36px;
  }
}
</style>
